<template>
	<div class="checkbox">
		<input class="checkbox__input" :id="id" :name="name" type="checkbox" :value="value" v-model="checkbox">
		<label class="label checkbox__label" :for="id">
				{{label}}
		</label>
	</div>
</template>

<script>
export default {
	name: 'CheckboxButton',
	props: {
		id: String,
		name: String,
		label: String,
		value: Number
	},
	computed: {
		checkbox: {
			get: function() {
				return this.label
			},
			set: function() {
				this.$emit("change", this.value)
			}
		}
	}
}
</script>